const PackagesTypes = {
  PACKAGES_LOADING: "PACKAGES_LOADING",
  GET_PACKAGES_SUCCESS: "GET_PACKAGES_SUCCESS",
  GET_PACKAGE_DETAILS_SUCCESS: "GET_PACKAGE_DETAILS_SUCCESS",
  GET_PACKAGE_ITEMS_SUCCESS: "GET_PACKAGE_ITEMS_SUCCESS",
  GET_AVAILABLE_PACKAGE_SERVICES_SUCCESS:
    "GET_AVAILABLE_PACKAGE_SERVICES_SUCCESS",
  CLEAR_AVAILABLE_PACKAGE_SERVICES: "CLEAR_AVAILABLE_PACKAGE_SERVICES",
};

export default PackagesTypes;
